import styled from 'styled-components';

import { Color, FontWeight, Spacing, Media } from '../../theme';

import LocalArrowIcon from './images/arrow.inline.svg';
import LocalQuotationIcon from './images/quotation.inline.svg';
import { ArrowContainerData, ContainerData } from './testimonialsSlider.types';

export const Container = styled.div<ContainerData>`
  position: relative;
  padding: 100px ${Spacing.DesktopWide};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props: ContainerData) => props.backgroundColor};
  ${Media.desktop`
    padding: 100px ${Spacing.Desktop};
  `}
  ${Media.tablet`
    padding: 100px ${Spacing.Tablet};
  `}
`;

export const ArrowContainer = styled.button<ArrowContainerData>`
  height: 64px;
  width: 64px;
  background-color: ${(props: ArrowContainerData) => props.backgroundColor};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  ${Media.mobile`
    display: none;
  `}
`;

export const LeftArrow = styled(LocalArrowIcon)`
  width: 20px;
  fill: ${Color.primary};
`;

export const QuotationIcon = styled(LocalQuotationIcon)`
  width: 58px;
  fill: ${Color.primary};
`;

export const RightArrow = styled(LocalArrowIcon)`
  width: 20px;
  transform: rotate(180deg);
  fill: ${Color.primary};
`;

export const Content = styled.div`
  color: ${Color.darkGrey};
  font-size: 25px;
  font-weight: ${FontWeight.Light};
  letter-spacing: 0.11px;
  line-height: 38px;
  text-align: center;
  margin: 20px 100px 30px;
  ${Media.tablet`
    margin: 20px 40px 30px;
    font-size: 20px;
    line-height: 28px;
  `}
  ${Media.mobile`
    margin: 20px 10px 30px;
  `}
`;

export const Author = styled.div`
  color: ${Color.darkGrey};
  font-size: 16px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 10px;
`;

export const AuthorAddress = styled.div`
  color: ${Color.primary};
  font-size: 12px;
  font-weight: ${FontWeight.Bold};
  letter-spacing: 0.92px;
  line-height: 15px;
  text-transform: uppercase;
`;

export const AuthorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TestimonialElem = styled.div`
  margin: 0 auto;
`;
